module.exports = __webpack_public_path__ + "img/form-settings-size.9e97b8ee.svg";